import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { databaseList, QueryRequest, QueryResponse, TableSchema, TableSchemaCriteria } from '../models';
import { SqlQueryDetailsState, SqlQueryState } from '../store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../store';

@Component({
  selector: 'opus-jobs-landing',
  templateUrl: './sql-query-landing.component.html'
})
export class SqlQueryLandingComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('editor') editorRef!: any;

  // private editor!: monaco.editor.IStandaloneCodeEditor;
  displayedColumns: string[] = [];

  criteria: TableSchemaCriteria = { database: databaseList[0].value };

  queryResponse: QueryResponse;
  queryResponse$: Observable<QueryResponse>;

  tableSchemas: TableSchema[] = [];
  tableSchemas$: Observable<TableSchema[]>;

  sqlQueryState: SqlQueryDetailsState;
  sqlQueryState$: Observable<SqlQueryDetailsState>;

  form: FormGroup;

  constructor(private store: Store<SqlQueryState>, private fb: FormBuilder) {
    this.sqlQueryState$ = this.store.pipe(select(fromStore.getSqlQueryDetailsState));
    this.queryResponse$ = this.store.pipe(select(fromStore.getSqlQueryResponse));
    this.tableSchemas$ = this.store.pipe(select(fromStore.getTableSchemas));
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      sql: ['SELECT TOP 10 s.Id, s.BlackoutEnd, s.BlackoutStart, s.CallDay, s.Code, s.DistrictId  FROM dbo.School s']
    });
  }
  ngAfterViewInit() {
    this.sqlQueryState$.subscribe(s => {
      this.sqlQueryState = s;
      console.log('sqlQueryState: ', this.sqlQueryState);
    });

    this.queryResponse$.subscribe(s => {
      this.queryResponse = s;
    });
  }

  executeQuery() {
    if (this.form.invalid) return;

    // Our query we'll fill in later
    const queryRequest: QueryRequest = {
      database: this.criteria.database,
      sql: null
    };

    Object.keys(this.form.controls).forEach(key => {
      const value = this.form.get(key).value;
      queryRequest[key] = value;
    });

    if (!queryRequest.sql) return;

    this.store.dispatch(new fromStore.RunSqlQuery(queryRequest));
  }

  onCriteriaChange(criteria: TableSchemaCriteria) {
    this.criteria = criteria;
    this.store.dispatch(new fromStore.LoadDatabaseSchemas(criteria));
  }

  ngOnDestroy() {
    // this.editor?.dispose();
  }

  getKeys(obj: any): string[] {
    const columns: string[] = [];
    for (let column in obj) {
      columns.push(column);
    }

    return columns;
  }

  getStyle(column: string): string {
    let columnStyle = 'white-space: nowrap;';
    columnStyle = `${columnStyle} min-width: ${column.length * 15}px`;

    // if (column.length < 10) {
    //   columnStyle = `${columnStyle} min-width: ${column.length * 10}px`;
    // } else if (column.length < 20) {
    //   columnStyle = `${columnStyle} min-width: ${column.length * 15}px`;
    // } else {
    //   columnStyle = `${columnStyle} min-width: ${column.length * 20}px`;
    // }

    return columnStyle;
  }

  displayValue(rowObj: Record<string, string>, column: string) {
    const value = rowObj[column]?.toString();

    if (!value) return '';

    if (value.length > 2 * column.length) {
      return `${value.substring(0, 2 * column.length)}...`;
    }
    return value;
  }
}
